import React, { Component } from 'react'
import PropTypes from 'prop-types'
import animations from './animations'

class FancySelectAdvanced extends Component {
    constructor (props) {
        super(props)

        this.list = []
    }

    componentDidMount () {
        this.setActiveItem()

        document.addEventListener('click', (event) => {
            if (this.inner) {
                const isClickInside = this.inner.contains(event.target)
                if (!isClickInside) {
                    this.initialise()
                    animations.toggleClose()
                }
            }
        })
    }

    componentDidUpdate (prevProps) {
	    if (prevProps.value !== this.props.value) {
	        this.setActiveItem()
        }
    }

    initialise () {
        animations.initialise(this.container, this.label, this.dropdown, this.bg)
    }

    setActiveItem () {
        if (this.props.list) {
            this.props.list.forEach((item, key) => {
                if (this.props.value === item.value) {
                    this.setValue(item.value, item.label)
                }
            })
        }
    }

    setValue (value, label) {
        this.props.setValue(value, label)
        this.label.innerHTML = label
    };

    handleSelection (value, label, event) {
        event.preventDefault()
        this.initialise()
        this.setValue(value, label)
        animations.toggleClose()
    }

    handleShowDropdown (event) {
	    if (this.props.disabled) {
	        return
        }
        event.preventDefault()
        this.initialise()
        if (this.dropdown && this.dropdown.offsetHeight > 1) {
            animations.toggleClose()
        } else {
            animations.toggleOpen()
        }
    }

    render () {
        const hasErrors = () => {
            return this.props.errors && this.props.errors[this.props.name]
        }

        const List = this.props.list.map((item, key) => {
            return (
                <a href='#' key={key} onClick={this.handleSelection.bind(this, item.value, item.label)} dangerouslySetInnerHTML={{ __html: item.label }} />
            )
        })

        return (
            <div className='fancy-select' ref={el => this.container = el}>
                {(this.props.title ? <div className='title input-label-styled'>{this.props.title}</div> : '')}
                <div className='inner' ref={el => this.inner = el} onClick={this.handleShowDropdown.bind(this)}>
                    <div className='bg' ref={el => this.bg = el} />
                    <a
                        href='#'
                        className={`label ${this.props.className ? this.props.className : ''} ${hasErrors() ? 'error' : ''}`}
                        ref={el => this.label = el}
                        onClick={event => event.preventDefault()}
                    >
                        <span>{(this.props.label ? this.props.label : 'Select Option:')}</span>
                    </a>
                    <div
                        className='dropdown'
                        ref={el => this.dropdown = el}
                    >
                        {List}
                    </div>
                </div>
            </div>
        )
    }
}

FancySelectAdvanced.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.object]),
    list: PropTypes.array.isRequired,
    setValue: PropTypes.func.isRequired,
    title: PropTypes.string,
    className: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    errors: PropTypes.object
}

export default FancySelectAdvanced



// WEBPACK FOOTER //
// ./resources/js/elements/FancySelect/FancySelectAdvanced.js